<template>
  <modal v-model="value.show" :klass="'ls-modal-large'">
    <div slot="content">
      <div class="ls-modal-header">
        <button type="button" close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">{{ $t('invoices.attributes.separate_invoice') }}</h4>
      </div>
      <form @submit.prevent="validateBeforeSubmit" class="ls-form ls-form-horizontal">
        <div data-test="invoices" class="ls-modal-body">
          <p>{{ $t('invoices.details.separate_invoice_information') }}</p>

          <fieldset class="ls-md-margin-bottom row">

            <label class="ls-label col-md-4 col-xs-12" :class="{'ls-error': errors.has($t('invoices.attributes.due_date')) }">
              <b class="ls-label-text">{{ $t('invoices.attributes.due_date') }}</b>
              <input
                class="ls-field-sm"
                type="date"
                data-test="'invoices.attributes.due_date'"
                v-validate="'required|date'"
                v-model="separateInvoice.due_date"
                :name="$t('invoices.attributes.due_date')">
                <small class="ls-help-message" v-show="errors.has($t('invoices.attributes.due_date'))">{{ errors.first($t('invoices.attributes.due_date')) }}</small>
            </label>

            <label class="ls-label col-md-4 col-xs-12" :class="{'ls-error': errors.has($t('invoices.details.value')) }">
              <b class="ls-label-text">{{ $t('invoices.details.value') }}</b>
              <money-input
                autocomplete="off"
                v-model="separateInvoice.value"
                :value="separateInvoice.value"
                @updateValue="(value) => { separateInvoice.value = value }"
                v-validate="'required'"
                :dataTest="'invoices.details.value'"
                :name="$t('invoices.details.value')">
              </money-input>
              <small class="ls-help-message" v-show="errors.has($t('invoices.details.value'))">{{ errors.first($t('invoices.details.value')) }}</small>
            </label>

            <label class="ls-label col-md-4 col-xs-12" :class="{'ls-error': errors.has($t('invoices.details.description')) }">
              <b class="ls-label-text">{{ $t('invoices.details.description') }}</b>
              <input
                class="ls-field"
                type="text"
                maxlength="40"
                data-test="invoices.details.description"
                v-validate="'required'"
                v-model="separateInvoice.description"
                :placeholder="$t('invoices.placeholder.add_separate_invoice')"
                :name="$t('invoices.details.description')">
              <small class="ls-help-message" v-show="errors.has($t('entries.description'))">{{ errors.first($t('invoices.details.description')) }}</small>
              <char-counter v-model="separateInvoice.description" v-show="!errors.has($t('invoices.details.description'))" :max="40"></char-counter>
            </label>

            <div class="btn-action ls-float-right">
            </div>

            <label class="ls-label col-md-12 col-xs-12 ls-display-flex">
              <input
                class = "ls-xs-margin-right"
                type="checkbox"
                v-model="separateInvoice.taxable"
                :required="false"
              />
              <b class="ls-label-text">Lançar impostos vinculados à assinatura</b>
            </label>

          </fieldset>
        </div>
        <div class="ls-modal-footer">
          <button type="button" class="ls-btn" data-dismiss="modal" close-modal>{{ $t('application.button.close') }}</button>
          <button class="ls-btn ls-btn-primary ls-float-right">{{ $t('application.button.launch') }}</button>
          <div class="ls-clearfix"></div>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Modal from 'src/app/components/shareds/modal/Modal'
  import MoneyInput from 'src/app/components/shareds/money-input/MoneyInput'
  import CharCounter from 'src/app/components/shareds/char-counter/CharCounter'

  export default {
    props: ['value'],
    components: { MoneyInput, Modal, CharCounter },
    data () {
      return {
        separateInvoice: {
          due_date: '',
          value: '',
          description: '',
          invoice_type: 'A',
          customer_id: '',
          taxable: true
        }
      }
    },
    mounted () {
    },
    computed: {
      ...mapGetters(['pagination', 'invoices', 'contract']),
      customerId () {
        return this.contract.customer.id
      }
    },
    methods: {
      ...mapActions(['createInvoice', 'loadContract']),
      ...mapMutations(['addFlash', 'clearFlash']),
      addResource () {
        this.$modalLoader.show()
        this.separateInvoice.customer_id = this.customerId
        return this.createInvoice({ invoice: this.separateInvoice, contract_id: this.contract.id })
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then(this.submitForm)
      },
      submitForm (success) {
        if (success) {
          this.addResource().then(this.afterAdd)
        }
      },
      afterAdd (response) {
        Promise.resolve(this.clearInvoice()).then(this.clearErrors)
        this.$modalLoader.hide()
        if (response.status === 201) {
          this.loadContract(this.$route.params.id).then(this.$parent.getInvoices)
        }
        this.value.show = false
        this.$parent.scrollToFlashMessage()
      },
      clearInvoice () {
        this.separateInvoice.due_date = ''
        this.separateInvoice.value = ''
        this.separateInvoice.description = ''
      },
      clearErrors () {
        this.$validator.reset()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalSeparateInvoice.vue?278fb27e